import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import { Button, Checkbox, Paper, Tab, Tabs, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Select, MenuItem, FormControl, InputLabel, IconButton, Chip, Snackbar, Alert, CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import GetAppIcon from "@mui/icons-material/GetApp";
import EditIcon from "@mui/icons-material/Edit";
import RefreshIcon from "@mui/icons-material/Refresh";
import * as XLSX from 'xlsx';
import { Send } from "react-bootstrap-icons";

const obtenerColorPrioridad = (prioridad) => {
    if (!prioridad) return "#999";

    switch (prioridad.toLowerCase()) {
        case "alta":
            return "#f3705a";
        case "normal":
            return "#5bc0de";
        case "baja":
            return "#f0ad4e";
        default:
            return "#999";
    }
};

const TablaTareas = () => {
    const [valorTab, setValorTab] = useState(0);
    const [tareas, setTareas] = useState([]);
    const [tareasSeleccionadas, setTareasSeleccionadas] = useState([]);
    const [dialogoAbierto, setDialogoAbierto] = useState(false);
    const [editandoTarea, setEditandoTarea] = useState(null);
    const [cargando, setCargando] = useState(false);
    const [guardando, setGuardando] = useState(false);  
    const [notificacion, setNotificacion] = useState({ open: false, message: '', severity: 'success' });
    const [datosTarea, setDatosTarea] = useState({
        asunto: "",
        prioridad: "normal",
        descripcion: "",
        estado: "pendiente",
        email: ""
    });
    const [emailUsuario, setEmailUsuario] = useState("");

    const normalizarDatosBackend = (respuestaBackend) => {
        if (respuestaBackend.email && respuestaBackend.actividades) {
            setEmailUsuario(respuestaBackend.email);

            return respuestaBackend.actividades.map((tarea) => ({
                id: tarea.idactividades,
                subject: tarea.asunto,
                priority: tarea.prioridad || "normal",
                description: tarea.descripcion,
                status: tarea.estado,
                correo: tarea.email,
                createdAt: tarea.fechadecreacion,
                updatedAt: tarea.fechademodificacion,
                idactividades: tarea.idactividades,
                idusuario: tarea.idusuario,
                asunto: tarea.asunto,
                prioridad: tarea.prioridad,
                descripcion: tarea.descripcion,
                estado: tarea.estado,
                email: tarea.email,
                fechadecreacion: tarea.fechadecreacion,
                fechademodificacion: tarea.fechademodificacion
            }));
        }
        else if (Array.isArray(respuestaBackend)) {
            return respuestaBackend.map((tarea) => ({
                id: tarea.idactividades,
                subject: tarea.asunto,
                priority: tarea.prioridad || "normal",
                description: tarea.descripcion,
                status: tarea.estado,
                correo: tarea.email,
                createdAt: tarea.fechadecreacion,
                updatedAt: tarea.fechademodificacion,
                idactividades: tarea.idactividades,
                idusuario: tarea.idusuario,
                asunto: tarea.asunto,
                prioridad: tarea.prioridad,
                descripcion: tarea.descripcion,
                estado: tarea.estado,
                email: tarea.email,
                fechadecreacion: tarea.fechadecreacion,
                fechademodificacion: tarea.fechademodificacion
            }));
        }

        return [];
    };

    useEffect(() => {
        cargarTareas();
    }, []);

    const enviarTareaADB = async (datosFormulario) => {
        const fechaActual = new Date().toISOString().split("T")[0];
        const idusuario = localStorage.getItem("idusuario");
        const emailFijo = emailUsuario || localStorage.getItem('nombre') || "sin-correo@demo.com";

        const datos = {
            idusuario,
            asunto: datosFormulario.asunto,
            prioridad: datosFormulario.prioridad,
            descripcion: datosFormulario.descripcion,
            estado: datosFormulario.estado,
            email: emailFijo,
            fechadecreacion: fechaActual,
            fechademodificacion: fechaActual,
        };

        console.log("Datos a enviar:", datos);

        try {
            const respuesta = await fetch(
                `${process.env.REACT_APP_API_URL}tareas/${idusuario}/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(datos),
                }
            );

            if (!respuesta.ok) {
                const errorText = await respuesta.text();
                throw new Error(`Error ${respuesta.status}: ${errorText}`);
            }

            const resultado = await respuesta.json();
            console.log("Tarea creada con éxito:", resultado);
            return resultado;

        } catch (error) {
            console.error("Error al guardar tarea:", error);
            throw error;
        }
    };

    const actualizarTareaEnDB = async (tarea, datosFormulario) => {
        const fechaActual = new Date().toISOString().split("T")[0];
        const idusuario = localStorage.getItem("idusuario");
        const emailFijo = emailUsuario || localStorage.getItem('nombre') || "sin-correo@demo.com";

        const datos = {
            idactividades: tarea.idactividades,
            idusuario,
            asunto: datosFormulario.asunto,
            prioridad: datosFormulario.prioridad,
            descripcion: datosFormulario.descripcion,
            estado: datosFormulario.estado,
            email: emailFijo,
            fechadecreacion: tarea.fechadecreacion,
            fechademodificacion: fechaActual,
        };

        try {
            const respuesta = await fetch(
                `${process.env.REACT_APP_API_URL}tareas/${idusuario}/`,
                {
                    method: "PUT", 
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(datos),
                }
            );

            if (!respuesta.ok) {
                const errorText = await respuesta.text();
                throw new Error(`Error ${respuesta.status}: ${errorText}`);
            }

            const resultado = await respuesta.json();
            console.log("Tarea actualizada con éxito:", resultado);
            return resultado;

        } catch (error) {
            console.error("Error al actualizar tarea:", error);
            throw error;
        }
    };

    const cargarTareas = async () => {
        setCargando(true);
        try {
            const respuesta = await fetch(
                process.env.REACT_APP_API_URL + "tareas/" + localStorage.getItem("idusuario") + "/",
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                }
            );

            if (!respuesta.ok) {
                throw new Error(`Error ${respuesta.status}: ${respuesta.statusText}`);
            }

            const datos = await respuesta.json();
            const tareasNormalizadas = normalizarDatosBackend(datos);

            setTareas(tareasNormalizadas);
            mostrarNotificacion('Tareas cargadas exitosamente', 'success');

        } catch (error) {
            console.error('Error al cargar tareas:', error);
            mostrarNotificacion(`Error al cargar tareas: ${error.message}`, 'error');
            setTareas([]);
        } finally {
            setCargando(false);
        }
    };

    const mostrarNotificacion = (mensaje, severidad = 'success') => {
        setNotificacion({ open: true, message: mensaje, severity: severidad });
    };

    const manejarSeleccionarTodas = (evento) => {
        if (evento.target.checked) {
            const todasSeleccionadas = tareas.map((_, index) => index);
            setTareasSeleccionadas(todasSeleccionadas);
        } else {
            setTareasSeleccionadas([]);
        }
    };

    const manejarSeleccionarTarea = (indice) => {
        const indiceSeleccionado = tareasSeleccionadas.indexOf(indice);
        let nuevasSeleccionadas = [];

        if (indiceSeleccionado === -1) {
            nuevasSeleccionadas = [...tareasSeleccionadas, indice];
        } else {
            nuevasSeleccionadas = tareasSeleccionadas.filter(i => i !== indice);
        }

        setTareasSeleccionadas(nuevasSeleccionadas);
    };

    const manejarAbrirDialogo = (tarea = null, indice = null) => {
        const emailAUsar = emailUsuario || localStorage.getItem('nombre') || "sin-correo@demo.com";

        if (tarea) {
            setEditandoTarea(indice);
            setDatosTarea({
                asunto: tarea.subject || tarea.asunto || "",
                prioridad: tarea.priority || tarea.prioridad || "normal",
                descripcion: tarea.description || tarea.descripcion || "",
                estado: tarea.status || tarea.estado || "pendiente",
                email: emailAUsar
            });
        } else {
            setEditandoTarea(null);
            setDatosTarea({
                asunto: "",
                prioridad: "normal",
                descripcion: "",
                estado: "pendiente",
                email: emailAUsar
            });
        }
        setDialogoAbierto(true);
    };

    const manejarCerrarDialogo = () => {
        setDialogoAbierto(false);
        setEditandoTarea(null);
        setDatosTarea({
            asunto: "",
            prioridad: "normal",
            descripcion: "",
            estado: "pendiente",
            email: ""
        });
    };


    const manejarGuardarTarea = async () => {
        if (!datosTarea.asunto.trim()) {
            mostrarNotificacion("Por favor ingresa un asunto", 'warning');
            return;
        }

        setGuardando(true);

        try {
            const hoy = new Date().toISOString().split('T')[0];
            const emailFijo = emailUsuario || localStorage.getItem('nombre') || "sin-correo@demo.com";

            if (editandoTarea !== null) {
                
                const tareaActual = tareas[editandoTarea]; 
                await actualizarTareaEnDB(tareaActual, datosTarea);
                const tareasActualizadas = [...tareas];
                tareasActualizadas[editandoTarea] = {
                    ...tareasActualizadas[editandoTarea],
                    subject: datosTarea.asunto,
                    priority: datosTarea.prioridad,
                    description: datosTarea.descripcion,
                    status: datosTarea.estado,
                    correo: emailFijo,
                    updatedAt: hoy,
                    asunto: datosTarea.asunto,
                    prioridad: datosTarea.prioridad,
                    descripcion: datosTarea.descripcion,
                    estado: datosTarea.estado,
                    email: emailFijo,
                    fechademodificacion: hoy
                };

                setTareas(tareasActualizadas);
                mostrarNotificacion('Tarea actualizada exitosamente', 'success');

            } else {
                const tareaCreada = await enviarTareaADB(datosTarea);
                const nuevaTarea = {
                    id: tareaCreada.idactividades || Date.now(),
                    subject: datosTarea.asunto,
                    priority: datosTarea.prioridad,
                    description: datosTarea.descripcion,
                    status: datosTarea.estado,
                    correo: emailFijo,
                    createdAt: hoy,
                    updatedAt: hoy,
                    idactividades: tareaCreada.idactividades,
                    idusuario: parseInt(localStorage.getItem("idusuario")) || 19284,
                    asunto: datosTarea.asunto,
                    prioridad: datosTarea.prioridad,
                    descripcion: datosTarea.descripcion,
                    estado: datosTarea.estado,
                    email: emailFijo,
                    fechadecreacion: hoy,
                    fechademodificacion: hoy
                };

                setTareas([...tareas, nuevaTarea]);
                mostrarNotificacion('Tarea creada exitosamente', 'success');
            }

            manejarCerrarDialogo();

        } catch (error) {
            console.error('Error al guardar tarea:', error);
            mostrarNotificacion(`Error al guardar tarea: ${error.message}`, 'error');
        } finally {
            setGuardando(false);
        }
    };

    const manejarDescargarExcel = () => {
        if (tareas.length === 0) {
            mostrarNotificacion("No hay tareas para descargar", 'warning');
            return;
        }

        const datosExcel = tareas.map((tarea) => ({
            'ID': tarea.id || tarea.idactividades,
            'Asunto': tarea.subject || tarea.asunto,
            'Prioridad': tarea.priority || tarea.prioridad || 'No especificada',
            'Estado': tarea.status || tarea.estado,
            'Descripción': tarea.description || tarea.descripcion || 'Sin descripción',
            'Fecha de creación': tarea.createdAt || tarea.fechadecreacion || '-',
            'Fecha de modificación': tarea.updatedAt || tarea.fechademodificacion || '-',
            'Correo': tarea.correo || tarea.email,
        }));

        const ws = XLSX.utils.json_to_sheet(datosExcel);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Tareas');

        const nombreArchivo = `tareas_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(wb, nombreArchivo);
        mostrarNotificacion('Excel descargado exitosamente', 'success');
    };

    const actualizarEstadoTarea = (indice, nuevoEstado) => {
        const tareasActualizadas = [...tareas];
        const hoy = new Date().toISOString().split('T')[0];

        tareasActualizadas[indice] = {
            ...tareasActualizadas[indice],
            status: nuevoEstado,
            updatedAt: hoy,
            estado: nuevoEstado,
            fechademodificacion: hoy
        };

        setTareas(tareasActualizadas);

        const mensajesEstado = {
            'En Progreso': 'Tarea iniciada',
            'en progreso': 'Tarea iniciada',
            'Completada': 'Tarea completada',
            'completada': 'Tarea completada'
        };

        const mensajeNotificacion = mensajesEstado[nuevoEstado] || 'Tarea actualizada';
        mostrarNotificacion(mensajeNotificacion, 'success');
    };

    const estaSeleccionada = (indice) => {
        return tareasSeleccionadas.includes(indice);
    };

    const obtenerValorTarea = (tarea, claveFrontend, claveBackend) => {
        return tarea[claveFrontend] || tarea[claveBackend] || '';
    };

    return (
        <Container fluid className="p-3">
            <Row className="mb-3 align-items-center">
                <Col xs={12} md={6}>
                    <Typography variant="h5">
                        Tareas
                        {cargando && <CircularProgress size={20} sx={{ ml: 1 }} />}
                    </Typography>
                </Col>
                <Col xs={12} md={6} className="d-flex justify-content-end">
                    <Button
                        variant="outlined"
                        startIcon={<RefreshIcon />}
                        onClick={cargarTareas}
                        disabled={cargando}
                        sx={{ borderRadius: '20px', textTransform: 'none' }}
                    >
                        Recargar
                    </Button>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col xs={12} className="d-flex justify-content-end">
                    <div className="d-flex gap-3">
                        <Button
                            className="botonPositivo3"
                            variant="contained"
                            startIcon={<GetAppIcon />}
                            onClick={manejarDescargarExcel}
                            disabled={tareas.length === 0}
                            sx={{ borderRadius: '20px', textTransform: 'none' }}
                        >
                            Descargar Excel
                        </Button>
                        <Button
                            className="botonPositivo3"
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={() => manejarAbrirDialogo()}
                            sx={{ borderRadius: '20px', textTransform: 'none' }}
                        >
                            Agregar Tarea
                        </Button>
                    </div>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col xs={12}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow style={{ backgroundColor: '#212529' }}>
                                    <TableCell style={{ color: 'white' }}>Asunto <FilterListIcon fontSize="small" /></TableCell>
                                    <TableCell style={{ color: 'white' }}>Prioridad <FilterListIcon fontSize="small" /></TableCell>
                                    <TableCell style={{ color: 'white' }}>Estado</TableCell>
                                    <TableCell style={{ color: 'white' }}>Fecha de creación</TableCell>
                                    <TableCell style={{ color: 'white' }}>Fecha de modificación</TableCell>
                                    <TableCell style={{ color: 'white' }}>Acciones</TableCell>
                                    <TableCell style={{ color: 'white' }}>Correo</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {cargando ? (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                                            <CircularProgress />
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                                Cargando tareas...
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : tareas.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                                            <Typography variant="body1" color="text.secondary">
                                                No hay tareas disponibles. Haz clic en "Agregar Tarea" para crear una.
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    tareas.map((tarea, indice) => {
                                        const asunto = obtenerValorTarea(tarea, 'subject', 'asunto');
                                        const prioridad = obtenerValorTarea(tarea, 'priority', 'prioridad');
                                        const estado = obtenerValorTarea(tarea, 'status', 'estado');
                                        const descripcion = obtenerValorTarea(tarea, 'description', 'descripcion');
                                        const fechaCreacion = obtenerValorTarea(tarea, 'createdAt', 'fechadecreacion');
                                        const fechaModificacion = obtenerValorTarea(tarea, 'updatedAt', 'fechademodificacion');
                                        const email = obtenerValorTarea(tarea, 'correo', 'email');

                                        return (
                                            <TableRow key={tarea.id || tarea.idactividades}>
                                                <TableCell>
                                                    <Typography variant="body2" fontWeight="500">
                                                        {asunto}
                                                    </Typography>
                                                    {descripcion && (
                                                        <Typography variant="caption" color="text.secondary">
                                                            {descripcion}
                                                        </Typography>
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            color: obtenerColorPrioridad(prioridad),
                                                            fontWeight: 500,
                                                            textTransform: 'capitalize'
                                                        }}
                                                    >
                                                        {prioridad || 'No especificada'}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    {estado === "pendiente" ? (
                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            onClick={() => actualizarEstadoTarea(indice, "en progreso")}
                                                        >
                                                            Iniciar
                                                        </Button>
                                                    ) : estado === "en progreso" || estado === "En Progreso" ? (
                                                        <Checkbox
                                                            checked={false}
                                                            onChange={() => actualizarEstadoTarea(indice, "completada")}
                                                        />
                                                    ) : (
                                                        <Checkbox checked disabled />
                                                    )}
                                                    <Chip
                                                        label={estado}
                                                        size="small"
                                                        sx={{
                                                            ml: 1,
                                                            textTransform: 'capitalize'
                                                        }}
                                                        color={
                                                            estado === 'completada' || estado === 'Completada' ? 'success' :
                                                                estado === 'en progreso' || estado === 'En Progreso' ? 'primary' :
                                                                    'default'
                                                        }
                                                    />
                                                </TableCell>
                                                <TableCell>{fechaCreacion || '-'}</TableCell>
                                                <TableCell>{fechaModificacion || '-'}</TableCell>
                                                <TableCell>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => manejarAbrirDialogo(tarea, indice)}
                                                        color="primary"
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell>{email}</TableCell>
                                            </TableRow>
                                        );
                                    })
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Col>
            </Row>

            {/* REMOVIDO: El botón "Guardar" que no tenía funcionalidad clara */}

            <Dialog open={dialogoAbierto} onClose={manejarCerrarDialogo} maxWidth="sm" fullWidth>
                <DialogTitle>{editandoTarea !== null ? 'Editar Tarea' : 'Nueva Tarea'}</DialogTitle>
                <DialogContent>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <TextField
                                margin="dense"
                                label="Email"
                                fullWidth
                                variant="outlined"
                                value={emailUsuario || datosTarea.email}
                                disabled
                                helperText="Email asignado automáticamente"
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Asunto"
                                fullWidth
                                variant="outlined"
                                value={datosTarea.asunto}
                                onChange={(e) => setDatosTarea({ ...datosTarea, asunto: e.target.value })}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel>Prioridad</InputLabel>
                                <Select
                                    value={datosTarea.prioridad}
                                    label="Prioridad"
                                    onChange={(e) => setDatosTarea({ ...datosTarea, prioridad: e.target.value })}
                                >
                                    <MenuItem value="baja">Baja</MenuItem>
                                    <MenuItem value="normal">Normal</MenuItem>
                                    <MenuItem value="alta">Alta</MenuItem>
                                </Select>
                            </FormControl>
                        </Col>
                        <Col xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel>Estado</InputLabel>
                                <Select
                                    value={datosTarea.estado}
                                    label="Estado"
                                    onChange={(e) => setDatosTarea({ ...datosTarea, estado: e.target.value })}
                                >
                                    <MenuItem value="pendiente">Pendiente</MenuItem>
                                    <MenuItem value="en progreso">En Progreso</MenuItem>
                                    <MenuItem value="completada">Completada</MenuItem>
                                </Select>
                            </FormControl>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <TextField
                                margin="dense"
                                label="Descripción"
                                fullWidth
                                multiline
                                rows={3}
                                variant="outlined"
                                value={datosTarea.descripcion}
                                onChange={(e) => setDatosTarea({ ...datosTarea, descripcion: e.target.value })}
                            />
                        </Col>
                    </Row>
                </DialogContent>
                <DialogActions>
                    <Button onClick={manejarCerrarDialogo} disabled={guardando}>
                        Cancelar
                    </Button>
                    <Button 
                        onClick={manejarGuardarTarea} 
                        variant="contained" 
                        disabled={guardando}
                    >
                        {guardando ? (
                            <>
                                <CircularProgress size={20} sx={{ mr: 1 }} />
                                {editandoTarea !== null ? 'Actualizando...' : 'Guardando...'}
                            </>
                        ) : (
                            editandoTarea !== null ? 'Actualizar' : 'Guardar'
                        )}
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={notificacion.open}
                autoHideDuration={4000}
                onClose={() => setNotificacion({ ...notificacion, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                    onClose={() => setNotificacion({ ...notificacion, open: false })}
                    severity={notificacion.severity}
                    sx={{ width: '100%' }}
                >
                    {notificacion.message}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default TablaTareas;